import styled from 'styled-components'
import { TrStyledProps } from './interfaces'

export const Trstyled = styled.tr<TrStyledProps>`
  font-size: 12px;
  ${p => (p.cursorPointer ? 'cursor: pointer;' : 'cursor: auto;')}
  display: grid;
  grid-template-columns: ${({ multiplier }) =>
    multiplier ? '70px 75px 70px 97px;' : '30% 20% 50%'};
  td {
    padding-bottom: 10px;
    line-height: 2;
  }
  .username {
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    width: 68px;
    padding-right: 5px;
  }
  .profit {
    text-align: right;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    max-width: 200px;
    p {
      text-overflow: ellipsis;
      overflow: hidden;
      padding-left: 4px;
      padding-right: 2px;
      max-width: ${({ multiplier }) => (multiplier ? '80px' : '100%')};
    }
    svg {
      margin: 0 5px 0 2px;
    }
    span {
      display: flex;
      align-items: center;
      white-space: nowrap;
    }
  }
  .multiplier {
    text-align: center;
    margin-left: 5px;
    p {
      text-overflow: ellipsis;
      overflow: hidden;
      padding-left: 4px;
      padding-right: 2px;
      max-width: 60px;
    }
  }
  .payout {
    padding-right: 5px;
    display: flex;
    align-items: center;
    p {
      text-overflow: ellipsis;
      overflow: hidden;
      max-width: 38px;
    }
    &.bet-amount {
      p {
        max-width: 80px;
      }
    }
  }
  .profit,
  .currency,
  .arrow {
    ${({ profit, strokeColor }) =>
      profit > 0 &&
      `text-shadow: 0 0 4px ${strokeColor}; filter: brightness(150%);`}
    path {
      fill: ${({ strokeColor }) => strokeColor};
    }
  }
`
